// extracted by mini-css-extract-plugin
export default {"secondary-link":"Lqt_jV9lrf1ptMGQH52t","all-risks-link":"TD0hGlGagKOnFbxHWOcI","policies-link":"tG3cHLGGDs0SVs2wUQSN"};